"use strict";

exports.__esModule = true;
exports.SingleDeviceGridHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Heading = require("../../Core/Heading");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SingleDeviceGridHeader = exports.SingleDeviceGridHeader = function SingleDeviceGridHeader() {
  return /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 4,
    ellipsize: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SingleDeviceGridHeader.headingLabel",
    defaultMessage: "Device"
  }));
};